import { render, staticRenderFns } from "./TabLeave.vue?vue&type=template&id=1edc785c&"
import script from "./TabLeave.vue?vue&type=script&lang=js&"
export * from "./TabLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports